// Efek "rounded morph" — dipakai di hampir semua tombol project PHP asli:
// transition-all + hover:rounded-xl + active:rounded-3xl + active:scale
export const MORPH_BTN = 'transition-all duration-300 ease-in-out hover:rounded-xl active:rounded-3xl active:scale-[0.98]';
export const MORPH_BTN_SM = 'transition-all duration-300 hover:rounded-xl active:rounded-3xl active:scale-[0.94]';
